module.exports = __webpack_public_path__ + "img/Icon-BlogArticle.9041ecf2.svg";